import { camelToSnakeCase } from '~utils/string';

const getValidDownpayment = (isConsumer, downpayment) => (isConsumer ? 0 : downpayment);

const META_HAS_DOWNPAYMENT = 'simulation_has_downpayment_meta';

export const getCreditSimulationState = ({ amount, currentTerm, downpayment, isConsumer }) => ({
  amount,
  term: currentTerm?.term,
  downpayment: getValidDownpayment(isConsumer, downpayment)
});

export const postDownpaymentInfoMapper = hasDownpaymentOption => [
  {
    kind: META_HAS_DOWNPAYMENT,
    value: camelToSnakeCase(hasDownpaymentOption.value)
  }
];
